import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { INVITATIONS_INPUT } from './topics';

export const UNCONFIRMED = 'INVITATIONS/UNCONFIRMED' as const;

export interface IUnconfirmedPayload {
  invitationId: string;
  name: string;
}

export interface IUnconfirmedAction {
  type: typeof UNCONFIRMED;
  payload: IUnconfirmedPayload;
}

export const unconfirmedActionSchema = objectSchemaOf<IUnconfirmedAction>({
  type: Joi.string().valid(UNCONFIRMED).required(),
  payload: objectSchemaOf<IUnconfirmedPayload>({
    invitationId: Joi.string().required(),
    name: Joi.string().required(),
  }).required(),
});

export const unconfirmed = actionCreator({
  type: UNCONFIRMED,
  topic: INVITATIONS_INPUT,
  schema: unconfirmedActionSchema,
});
